import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  titleRoot: {
    padding: theme.spacing(3, 3, 1),
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 700,
    lineHeight: 1.3,
    color: '#172024',
    marginBottom: theme.spacing(0.75),
  },
  content: {
    padding: theme.spacing(0, 3, 1),
    overflowY: 'auto',
  },
  tabs: {
    marginBottom: theme.spacing(2),
  },
  listDivider: {
    marginBottom: theme.spacing(1),
  },
  errorText: {
    color: theme.palette.error.main,
    fontSize: '0.875rem',
    lineHeight: 1.4,
    marginBottom: theme.spacing(1.5),
  },
  contactList: {
    maxHeight: 320,
    overflowY: 'auto',
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  selectAllRow: {
    paddingTop: theme.spacing(1.25),
    paddingBottom: theme.spacing(1.25),
    minHeight: 52,
  },
  contactRow: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    minHeight: 56,
  },
  contactText: {
    flex: '1 1 auto',
    minWidth: 0,
    '& .MuiListItemText-primary': {
      fontSize: '0.9375rem',
      fontWeight: 600,
      lineHeight: 1.4,
      color: '#172024',
    },
    '& .MuiListItemText-secondary': {
      fontSize: '0.8125rem',
      lineHeight: 1.4,
      marginTop: 2,
    },
  },
  actions: {
    padding: theme.spacing(2, 3, 3),
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
  },
  actionsWrapper: {
    padding: theme.spacing(2, 3, 3),
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
  },
  noLeadsWrapper: {
    minHeight: 280,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(3),
    textAlign: 'center',
  },
  emptyTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.4,
    color: '#172024',
  },
  emptyCaption: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
    maxWidth: 360,
  },
  bodyText: {
    fontSize: '0.9375rem',
    lineHeight: 1.5,
    color: theme.palette.text.primary,
  },
  loading: {
    alignSelf: 'center',
    margin: theme.spacing(2, 0),
  },
  resultTitle: {
    fontSize: '1.25rem',
    fontWeight: 700,
    lineHeight: 1.3,
    color: '#172024',
    textAlign: 'center',
    width: '100%',
  },
}))

export default useStyles
